import React, {useEffect, useState} from "react";
import {Row, Col} from "react-bootstrap";
import dateFormat from "dateformat";
import {SvgIconComponent} from "@Components/Elements";


import IR from "./icon-v.svg";
import ID1 from "./i-dash-down.svg";
import ID2 from "./i-dash-up.svg";
import ICl from "./i-pdf.svg";


interface QyvoUserClaimsListClaimComponentProps {
    claimData: any;
    i: number;
}


export const QyvoUserClaimsListClaimComponent:React.FC<QyvoUserClaimsListClaimComponentProps> = ({
    claimData, i
}) => {


    const [claimInformationOpenStatus, setClaimInformationOpenStatus] = useState(false);

    useEffect(() => {
        return () => {
            setClaimInformationOpenStatus(false);
        };
    }, []);


    if (!claimData) {
        return null;
    }


    const {
        qyvo_user_claim_request_id,
        qyvo_user_claim_request_name,
        qyvo_user_claim_documents,
        qyvo_user_claim_request_data,
        qyvo_user_claim_request_create_date
    } = claimData;

    const qyvo_user_claim_request_expectation_date = qyvo_user_claim_request_create_date;


    // @ts-ignore
    const qyvo_user_claim_documents_list = qyvo_user_claim_documents.map((item, i) => {
        return (
            <Col xs={12} key={item.qyvo_user_claim_request_document_id} className={'qyvo-user-claims-list__qyvo-user-claim__claim-information__information-documents__document-element'}>
                <span>Example File Description: {item.qyvo_user_uploaded_document_name}</span>
                <SvgIconComponent iconSource={ICl} />
            </Col>
        );
    });


    return (
        <Col xs={12} className={`qyvo-user-claims-list__qyvo-user-claim ${claimInformationOpenStatus ? 'qyvo-user-claims-list__qyvo-user-claim--claim-opened' : ''}`}>
            <Row className={'qyvo-user-claims-list__qyvo-user-claim__claim-content'}>

                <Col xs={6} lg={2} className={'qyvo-user-claims-list__qyvo-user-claim__claim-name'}>
                    <span>Claim {i + 1}</span>
                </Col>

                <Col xs={3} lg={2} className={'qyvo-user-claims-list__qyvo-user-claim__claim-create-date'}>
                    <span>{dateFormat(qyvo_user_claim_request_create_date, 'mmm dd, yyyy')}</span>
                </Col>

                <Col xs={3} lg={2} className={'qyvo-user-claims-list__qyvo-user-claim__expectation-date'}>
                    <span>{dateFormat(qyvo_user_claim_request_expectation_date, 'mmm dd, yyyy')}</span>
                </Col>

                <Col xs={6} lg={1} className={'qyvo-user-claims-list__qyvo-user-claim__claim-refund-value'}>
                    <span>0 $</span>
                </Col>

                <Col xs={6} lg={2} className={'qyvo-user-claims-list__qyvo-user-claim__claim-status'}>
                    <span className={'status-badge-component'}>
                        <SvgIconComponent iconSource={IR} className={'status-badge-component__status-icon'} />
                        <span className={'status-badge-component__status-text'}>Verification</span>
                    </span>
                </Col>

                <Col xs={10} lg={2} className={'qyvo-user-claims-list__qyvo-user-claim__claim-payment-status'}>
                    <span>-</span>
                </Col>

                <Col xs={2} lg={1} className={'qyvo-user-claims-list__qyvo-user-claim__claim-visibility-switcher'} onClick={() => setClaimInformationOpenStatus(!claimInformationOpenStatus)}>
                    <SvgIconComponent iconSource={claimInformationOpenStatus ? ID2 : ID1} />
                </Col>

                {claimInformationOpenStatus &&
                <Col xs={12} className={'qyvo-user-claims-list__qyvo-user-claim__claim-information'}>
                    <Row className={'qyvo-user-claims-list__qyvo-user-claim__claim-information__information-content'}>
                        <Col xs={12} className={'qyvo-user-claims-list__qyvo-user-claim__claim-information__information-header'}>
                            <span>Claim details</span>
                        </Col>
                        <Col xs={12} className={'qyvo-user-claims-list__qyvo-user-claim__claim-information__information-documents'}>
                            <Row className={'qyvo-user-claims-list__qyvo-user-claim__claim-information__information-documents__documents-content'}>
                                {qyvo_user_claim_documents_list}
                            </Row>
                        </Col>
                    </Row>
                </Col>
                }

            </Row>
        </Col>
    )

};


export default QyvoUserClaimsListClaimComponent;
